import React, { PureComponent, Fragment } from 'react';
import { withNamespaces } from 'react-i18next';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';

import AddIcon from '@material-ui/icons/Add';
import IconButton from '@material-ui/core/IconButton';

import combineStyles from '../../utils/combineStyles';
import CollapseWrapperStyles from '../../styles/components/collapseWrapper';
import TypographyStyles from '../../styles/typography';
import ButtonStyles from '../../styles/button';
import DocumentsSectionStyles from './__styles__/DocumentsSection.styles';

import CollapseWrapper from '../Global/CollapseWrapper';
import UploadedDocument from '../Global/UploadedDocument';
import RequiredDocument from '../Global/RequiredDocument';
import FileUpload from '../Global/FileUpload/FileUpload';

export class DocumentsSection extends PureComponent {
  state = {
    isOpenFileUploader: false,
    shipmentDocumentTypeId: null,
    maxNumberOfFiles: null
  };

  _handleAddFiles = () => this.setState({ isOpenFileUploader: true });

  _handleAddRequiredFile = requiredFile =>
    this.setState({
      isOpenFileUploader: true,
      shipmentDocumentTypeId: requiredFile,
      maxNumberOfFiles: 1
    });

  _handleCloseFileUploader = () =>
    this.setState(
      {
        isOpenFileUploader: false,
        shipmentDocumentTypeId: null,
        maxNumberOfFiles: null
      },
      this._reloadFiles
    );

  _reloadFiles = () => {
    //TODO fetch documents
  };

  render() {
    const { t, classes } = this.props;
    return (
      <Fragment>
        <CollapseWrapper
          classes={{
            root: classes.root,
            header: classes.panelHeader,
            expandButton: classes.expandButton,
            bodyRoot: classes.collapsePanelBodyRoot
          }}
          header={() => (
            <div className={classes.titleWrapper}>
              <h2 className={classnames(classes.headline8, classes.title)}>
                {t('Documents')}
              </h2>
              <IconButton
                color="primary"
                onClick={this._handleAddFiles}
                className={classes.addDocumentsButton}
              >
                <AddIcon />
              </IconButton>
            </div>
          )}
          body={
            <Fragment>
              <Divider />
              <div className={classes.body}>
                <UploadedDocument
                  key={1}
                  file={{
                    fileTypeId: 'PDF',
                    shipmentDocumentTypeId: 'BOL',
                    uploadedFileName: 'bol-filename-123.pdf'
                  }}
                  onTag={() => {}}
                  onDelete={() => {}}
                  reloadFiles={() => {}}
                  editable={true}
                />
                <Divider className={classes.divider} />
                <UploadedDocument
                  key={2}
                  file={{
                    fileTypeId: 'PNG',
                    shipmentDocumentTypeId: 'INVOICE',
                    uploadedFileName: 'invoiceName_1233435ABCDEFGH_01234121'
                  }}
                  onTag={() => {}}
                  onDelete={() => {}}
                  reloadFiles={() => {}}
                  editable={true}
                />
                <div>
                  <Divider className={classes.divider} />
                  <RequiredDocument
                    onClick={this._handleAddRequiredFile}
                    requiredFile={'Doc Title'}
                    classes={{
                      root: classes.requiredDocumentRoot
                    }}
                  />
                  <Divider className={classes.divider} />
                  <RequiredDocument
                    onClick={this._handleAddRequiredFile}
                    requiredFile={'Doc Title'}
                    classes={{
                      root: classes.requiredDocumentRoot
                    }}
                  />
                </div>
              </div>
            </Fragment>
          }
        />
        {this.state.isOpenFileUploader && (
          <FileUpload
            open={true}
            onClose={this._handleCloseFileUploader}
            params={{
              shipmentId: this.state.shipmentId,
              shipmentDocumentTypeId: this.state.shipmentDocumentTypeId
            }}
            restrictions={{
              maxNumberOfFiles: this.state.maxNumberOfFiles
            }}
          />
        )}
      </Fragment>
    );
  }
}

export default withStyles(
  combineStyles(
    DocumentsSectionStyles,
    ButtonStyles,
    CollapseWrapperStyles,
    TypographyStyles
  )
)(withNamespaces()(DocumentsSection));
